export default __webpack_public_path__ + "static/media/noun-coins-919008.7800d7aa.svg";